<template>
  <div>
    <transition name="modal">
      <div v-if="showModal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-full" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h2 class="modal-title">
                    <slot name="modalHeader"></slot>
                  </h2>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                    <img src="@/assets/icons/menu/windows_control/Close_1.svg" class="" alt="Close" />
                    <!-- <span aria-hidden="true">&times;</span> -->
                  </button>
                </div>
                <div class="modal-body">
                  <slot name="modalBody"></slot>
                </div>
                <div class="modal-footer">
                  <slot name="modalFooter"></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(64, 157, 164, 0.6);
  display: table;
  transition: opacity 0.3s ease;
}
.close {
  opacity: unset !important;
  /*position: absolute;
  top: 10px;
  right: 10px;
  background-color: #ff1800 !important;
  border-radius: 50%;
  padding: 6px !important;
  display: flex;
  align-items: center;
  justify-content: center;*/
  img{
    width: 30px;
  }
}
.modal-header {
  border-bottom: unset;
  //padding: 1em 1.5em;
}
.modal-footer {
  border-top: unset;
  padding: 2em 1.5em;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-full {
  min-width: 98%;
}
.modal-body {
  overflow-y: auto;
  padding: 1em 1.5em;
}
.modal-full .modal-content {
  min-height: 95vh;
  max-height: 95vh;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
@media (max-width: 1027px) {
  .modal-content {
    top: -300px;
  }
}
</style>
